import * as React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

/**
 * Attempts to automatically format data. Bit of a hack - use formatted data
 * where possible.
 *
 * Doesn't work with all data, test before using.
 */
function autoFormat(text) {
  if (typeof text === 'boolean') {
    return [{
      size: 'small',
      word: text ? 'Yes' : 'No'
    }];
  } else if (typeof text !== 'string') {
    return [{
      size: 'small',
      word: '-'
    }];
  }

  return text.replace(/\b\//g, ' /').split(/(?!\(.*)\s(?![^(]*?\))/g).map(function (word) {
    return {
      word: word,
      size: !hasSubscript(word) && (/\d/.test(word) || word === '-') ? 'big' : 'small'
    };
  }).reduce(function (words, word, i) {
    if (i !== 0 && word.size === words[words.length - 1].size) {
      words[words.length - 1].word += " ".concat(word.word);
      return words;
    }

    return words.concat(word);
  }, []);
}

var hasSubscript = function hasSubscript(text) {
  var subscript = /\(([^)]+)\)/.exec(text);
  return subscript;
};

var ProductTableDataAuto = function ProductTableDataAuto(_ref) {
  var text = _ref.text,
      headerImage = _ref.headerImage;
  return _jsx("div", {
    children: autoFormat(text).map(function (_ref2, index) {
      var word = _ref2.word,
          size = _ref2.size;
      return size === 'small' ? _jsx("span", {
        sx: {
          margin: '0 5px',
          variant: "compounds.product-table.".concat(headerImage && 'variants.redesign.', "cellContent.content.small")
        },
        children: word
      }, index) : word;
    })
  });
};

var PlainProductTableDataAuto = function PlainProductTableDataAuto(props) {
  var text = props.text;
  return text;
};

export default ProductTableDataAuto;
export var Rich = ProductTableDataAuto;
export var Plain = PlainProductTableDataAuto;
//# sourceMappingURL=data-auto.js.map